export default __webpack_public_path__ + "static/media/somya.08bad737.jpg";